const TIME_RANGES = [
  { value: 'now 4-H', label: 'Последние 4 часа' },
  { value: 'now 1-d', label: 'Последние 24 часа' },
  { value: 'now 2-d', label: 'Последние 2 дня' },
  { value: 'now 7-d', label: 'Последние 7 дней' },
  { value: 'now 30-d', label: 'Последние 30 дней' },
];

export { TIME_RANGES }; 